import { apiRequest } from './apiClient.js';

export const deliveryRequestService = {
  getOptions: () => apiRequest('/delivery-requests/options'),
  submit: (payload) => apiRequest('/delivery-requests', { method: 'POST', body: JSON.stringify(payload) }),
};
